// src/services/authService.js

export const loginUserAPI = async (email, password) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/login`;

    const options = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify({
        email,
        password,
      }),
    };
    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

export const loginClientUserAPI = async (email, password, redirect_url) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/user/login`;

    const options = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify({
        email,
        password,
        redirect_url,
      }),
    };
    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

/**
 * UPDATED: accept a single payload object and send a FLAT JSON body.
 * Frontend should call like:
 * signupClientUserAPI({
 *   first_name, last_name, email, password,
 *   phone_country_code: phoneCountryCode,
 *   phone_number: phoneNumber,
 *   redirect_url
 * })
 */
export const signupClientUserAPI = async (payload) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/user/signup`;

    // Build flat body (no nesting under { email: {...} }, no per-field stringify)
    const body = {
      first_name: String(payload.first_name || "").trim(),
      last_name: String(payload.last_name || "").trim(),
      email: String(payload.email || "").trim().toLowerCase(),
      password: String(payload.password || ""),
      phone_country_code: String(payload.phone_country_code || ""),
      phone_number: String(payload.phone_number || ""),
      redirect_url: String(payload.redirect_url || ""),
    };

    const options = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify(body),
    };
    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

export const getAccessToken = () => {
  try {
    const raw = localStorage.getItem("access_token");
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const fetchUserTokens = async (type) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/users/tokens/` + type;

    const options = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: getAccessToken(),
      }),
    };

    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

export const forgotPasswordClientUserAPI = async (email, redirect_url) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/forgot-password/client`;

    const options = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify({
        email,
        redirect_url,
      }),
    };
    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

export const resetPasswordLinkVerify = async (token) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/forgot-password/client/verify-link`;

    const options = {
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify({ token }),
    };

    const response = await fetch(url, options);
    if (response.status === 200) {
      return true;
    } else {
      throw new Error("Link verified");
    }
  } catch (err) {
    throw err;
  }
};

export const resetPasswordAPI = async (token, password, confirm_password) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/reset-password/client`;

    const options = {
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: token,
      }),
      body: JSON.stringify({
        password,
        confirm_password,
      }),
    };

    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

export const fetchUsersAPI = async () => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/users/all`;

    const options = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: getAccessToken(),
      }),
    };

    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};

export const fetchUserTokensAPI = async (type) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/users/tokens/` + type;

    const options = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: getAccessToken(),
      }),
    };

    return await fetch(url, options);
  } catch (err) {
    throw err;
  }
};
